import { State } from '../StateTypes';

/**
 * Select raw data state slice - a slice intended for helping normalizing state.
 * See https://redux.js.org/usage/structuring-reducers/normalizing-state-shape
 * for info on normalized redux structure.
 *
 * @param state
 */
export const selectRawData = (state: State) => state.rawData;

/**
 * Select raw items state slice
 * @param state
 */
export const selectRawItems = (state: State) => selectRawData(state).products;

/**
 * Select raw item by id
 * @param state
 * @param id
 */
export const selectRawItem = (state: State, id: number) =>
  selectRawItems(state)[id];

/**
 * Select raw items by array of ids
 * @param state
 * @param itemIds
 */
export const selectRawItemsByIds = (state: State, itemIds: number[]) => {
  const rawItems = selectRawItems(state);
  return itemIds.map(itemId => rawItems[itemId]);
};
